<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background"
        :show="headerLoader || loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <div class="alert-body mt-1">
            <span v-if="errorMsg">{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-card
          class="card-transaction"
          no-body
        >
          <b-card-header class="d-flex justify-content-center align-items-center">
            <div class="d-flex flex-column">
              <div class="text-center">
                <h4>
                  {{ $t('DEBTIA_YOU_OWE') }}
                </h4>
                <p class="text-danger font-weight-bold text-custom-font">
                  {{ formatCurrency(restAmount) }}
                </p>
                <p>{{ $t('DEBTIA_TO') }}</p>
                <p>{{ clientsData.client_name }}</p>
              </div>
              <b-alert
                v-if="fullPaymentStatus === true"
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>{{ $t('DEBTIA_PAYMENT_REGISTERED_AWAITING_APPROVAL') }}</span>
                </div>
              </b-alert>
              <div v-if="showAnyButton">
                <b-button-group>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="mr-1"
                    @click="submitHandler($event, 1)"
                  >
                    {{ $t('DEBTIA_FULL_PAYMENT') }}
                  </b-button>
                  <b-button
                    v-if="showInstallmentBtn"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="mr-1"
                    @click="submitHandler($event, 0)"
                  >
                    {{ $t('DEBTIA_AGREEMENT_LINK') }}
                  </b-button>
                </b-button-group>
              </div>
            </div>
          </b-card-header>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BButtonGroup, BOverlay, BButton, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
import axios from '@axios'
import axiosRaw from 'axios'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'

export default {
  inject: ['sharedState'],
  components: {
    BRow,
    BCol,
    BCard,
    BButtonGroup,
    BCardHeader,
    BOverlay,
    BButton,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
    bcCaseId: {
      type: String,
      required: true,
    },
    restAmount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      clientsData: {},
      details: {},
      caseId: this.$route.params.id,
      installmentPlanData: [],
      debtorRemainingAmount: 0,
      adminSettingsDetails: [],
      fullPaymentStatus: null,
      errorMsg: '',
      constants,
    }
  },
  computed: {
    headerLoader() {
      return (
        this.restAmount === null
      || this.restAmount === undefined
      || !this.clientsData.client_name
      )
    },
    showFullPaymentBtn() {
      return this.fullPaymentStatus !== true && this.debtorRemainingAmount > 0 && this.installmentPlanData.length === 0
    },
    showInstallmentBtn() {
      return (
        this.fullPaymentStatus !== true
        && this.debtorRemainingAmount > 0
        && this.installmentPlanData.length === 0
      )
    },
    showAnyButton() {
      return this.showFullPaymentBtn || this.showInstallmentBtn
    },
    debtorContactPhone() {
      return this.sharedState.debtorContact.phone
    },
    debtorContactEmail() {
      return this.sharedState.debtorContact.email
    },
  },
  watch: {
    'sharedState.clientsData': {
      handler(val) {
        this.clientsData = val
      },
      deep: true,
    },
    'sharedState.remainingDebtAmount': {
      handler(newVal) {
        this.debtorRemainingAmount = newVal
      },
    },
  },
  created() {
    EventBus.$on('getInstallmentPlanData', data => {
      this.installmentPlanData = data
      this.$watch('installmentPlanData', () => {}, { deep: true, immediate: true })
    })
    this.getAdminSettingDetails()
  },
  mounted() {
    EventBus.$on('fullPaymentStatus', status => {
      this.fullPaymentStatus = status
    })
  },
  methods: {
    formatCurrency(amount) {
      const currency = 'DKK'
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency }).format(parseFloat(amount).toFixed(2))
    },
    getFirstDateOfNextMonth() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const firstOfNextMonth = new Date(year, month + 1, 1)

      return `${firstOfNextMonth.getFullYear()}-${
        String(firstOfNextMonth.getMonth() + 1).padStart(2, '0')}-${
        String(firstOfNextMonth.getDate()).padStart(2, '0')}`
    },
    getAdminSettingDetails() {
      const headers = {
        clientId: constants.clientID,
        secret: constants.secret,
      }
      axios.get(`${constants.serverBaseUrl}/api/v1/external/debtiaapp/user-settings/get-all`, {
        headers,
      }).then(response => {
        if (response.status && response.data && response.data.data) {
          this.adminSettingsDetails = response.data.data
        }
      }).catch(err => {
        console.error('Admin settings error:', err.response?.data)
      })
    },
    getSettingValue(key) {
      const item = this.adminSettingsDetails.find(i => i.key === key)
      return item ? item.value : null
    },
    submitHandler(evt, fullPayment) {
      evt.preventDefault()
      this.loader = true
      this.details.journal_id = this.bcCaseId
      this.details.debtia_debt_case_id = this.caseId
      this.details.period_based_plan = fullPayment ? 0 : Number(this.getSettingValue('period_base_plan'))
      this.details.amount_based_plan = fullPayment ? 0 : Number(this.getSettingValue('amount_base_plan'))
      this.details.max_months = Number(this.getSettingValue('max_amount'))
      this.details.min_amount = Number(this.getSettingValue('min_amount'))
      this.details.interest_free_months = Number(this.getSettingValue('interest_free_months'))
      this.details.payment_method = 4
      this.details.payment_date = this.getFirstDateOfNextMonth()
      this.details.send_method = 'none'
      this.details.employee_name = JSON.parse(localStorage.getItem('userData')).data.name

      const data = { ...this.details }
      const headers = {
        clientId: constants.debtiaappClientID,
        secret: constants.debtiaappSecret,
      }

      axiosRaw.post(`${constants.paymentsBaseUrl}/installment_plan/generate_agreement_link`, data, { headers })
        .then(response => {
          const tokenUrl = response.data.tokenized_url
          window.open(tokenUrl, '_blank')

          data.token = tokenUrl.split('/').pop()
          data.recipient_email = data.debtor_email
          data.recipient_phone = data.debtor_phone
          data.debt_case_id = this.caseId

          return axios.post(`${constants.baseUrl}/installment-plan/save`, data)
        })
        .then(responseLocal => {
          if (responseLocal.status) {
            this.errorMsg = ''
            // this.$toast({
            //   component: ToastificationContent,
            //   position: 'top-right',
            //   props: {
            //     title: 'Success',
            //     icon: 'CoffeeIcon',
            //     variant: 'primary',
            //     text: i18n.t('DEBTIA_AGREEMENT_LINK_GENERATION_SUCCESS'),
            //   },
            // })
          }
        })
        .catch(err => {
          if (err.response && err.response.status !== 200) {
            this.loader = false
            let msg
            switch (err.response.data.message) {
              case 'An active installment plan already exists against this Case!':
                msg = i18n.t('DEBTIA_INSTALLMENT_PLAN_ALREADY_EXISTS')
                break
              case 'The payment has been registered against this case and is awaiting approval.':
                msg = i18n.t('DEBTIA_PAYMENT_REGISTERED_AWAITING_APPROVAL')
                break
              default:
                msg = i18n.t('DEBTIA_ERROR_SUPPORT')
            }
            this.errorMsg = msg
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

  },
}

</script>

<style>
.text-custom-font{
  font-size: 20px;
  margin-top: 20px;
}
</style>
